import logo from './logo.svg';
import './App.css';
import ContentWrapper from "./ContentWrapper";

function App() {
  return (
    <div className="App">
      {/*<header className="App-header">*/}
      {/*  <img src={logo} className="App-logo" alt="logo" />*/}
      {/*  <p>This regional site is currently under construction!</p>*/}
      {/*  <a*/}
      {/*    className="App-link"*/}
      {/*    href="https://www.nats.org"*/}
      {/*    target="_blank"*/}
      {/*    rel="noopener noreferrer"*/}
      {/*  >NATS</a>*/}
      {/*</header>*/}
        <ContentWrapper />
        {/*<main>*/}
        {/*    <section>*/}
        {/*        <h2>Join us for Chapter Auditions - October 23, 2021.</h2>*/}
        {/*        <p>Founded in 1944, National Association of Teachers of Singing, Inc. (NATS) is the largest professional association of teachers of singing in the world with nearly 7,000 members in the United States, Canada, and nearly 30 other countries.</p>*/}
        {/*        <p>Ozark NATS includes members who live or work in Southwest Missouri.</p>*/}
        {/*    </section>*/}
        {/*</main>*/}
        {/*<Leadership president="Ann Marie Wilcox-Daehn" vp="Jena Cantrell" secretary="Sarah Howes" />*/}

    </div>
  );
}

export default App;
